export const CREDIT_APPLICATION_STATE_PENDING = 'PENDING';
export const CREDIT_APPLICATION_STATE_APPROVED = 'APPROVED';
export const CREDIT_APPLICATION_STATE_OPEN = 'OPEN';
